import React, { useEffect, useState } from "react";
import { getParmUrl, getFormatDate, getCookie } from "@/public/utils";
import _lodash, { get } from "lodash";
import "./common.less";
import {
  queryAuditInfoApi,
  baseInfoScsStatusQuery,
  queryIsNeedQuaAuditApi,
} from "./../service";
import "moment/locale/zh-cn";
import {
  CloseCircleFilled,
  CheckCircleFilled,
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
const AuditInformation = (props) => {
  const [auditData, setauditData] = useState({
    failure_reason: "",
    submit_time: null,
  });
  const [status, setstatus] = useState();
  /**
   * show的示例值解释：
   * refuse:审核失败，wait：信息审核中，all_pass:流程结束，审核通过,
   * part_pass:部分资质审核通过，合规资质待提交,
   * qua_wait:合规资质已提交，待审核
   */
  const [show, setShow] = useState("");

  const queryRefuseReason = async () => {
    try {
      // const res = await queryAuditInfoApi();
      const res1 = await baseInfoScsStatusQuery({
        supplier_code: getCookie("supplier_code"),
      });
      // const res2 = await queryIsNeedQuaAuditApi();
      if (res1.data.code == "0") {
        // var needAudit = get(res2, "data.data");
        setauditData({
          ...auditData,
          ...get(res1, "data.data"),
        });
        console.log(res1)
        var status = get(res1, "data.data.supplier_status");
        setstatus(status);
        setShowByStatus(status);
      }
    } catch (err) {
      return null;
    }
  };

  const setShowByStatus = (status, needAudit) => {
    // 根据 supplier_status 枚举判断显示状态
    // ScsBaseWaitSubmit: SCS基础信息待提交
    // ScsBaseWaitAudit: SCS基础信息待审核
    // ScsQuaWaitReplenish: SCS资质信息待补充
    // WaitFirstAudit: 待审核
    // FinalAuditOK: 审核通过
    // FinalAuditRefused: 终审拒绝
    if (status === "ScsBaseWaitAudit" || status === "WaitFirstAudit") {
      // 基础信息待审核 / 待审核
      setShow("wait");
    }
    if (status === "ScsQuaWaitReplenish") {
      // SCS资质信息待补充
      setShow("part_pass");
    }
    if (status === "FinalAuditOK") {
      // 审核通过
      setShow("all_pass");
    }
    if (status === "FinalAuditRefused") {
      // 终审拒绝
      setShow("refuse");
    }
    if (status === "ScsBaseWaitSubmit") {
      // SCS基础信息待提交
      setShow("base_wait_submit");
    }
    if (props.showWait) {
      // 合规资质已提交
      setShow("qua_submit");
    }
  };

  const jumpDom = () => {
    var aObj = {
      ScsBaseWaitSubmit: (
        <a
          className="openerA"
          rel="opener"
          href={
            "/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry?type=change&opration=perfection&current=" +
            0
          }
        >
          前往填写
        </a>
      ),
      ScsQuaWaitReplenish: (
        <a
          className="openerA"
          rel="opener"
          target="_blank"
          href={
            "/main/suppliersettlement/compliancecertification/index?type=change&opration=perfection&&sid=" +
            getParmUrl("sid")
          }
        >
          前往认证
        </a>
      ),
      FinalAuditRefused: (
        <a
          className="openerA"
          rel="opener"
          href={
            "/main/suppliersettlement/compliancecertification/index?type=change&opration=perfection&&sid=" +
            getParmUrl("sid")
          }
        >
          前往重新上传
        </a>
      ),
    };
    return aObj[status];
  };

  const errDom = (show) => {
    if (show == "all_pass") {
      return (
        <span>
          <div style={{ margin: "24px 0px", fontSize: "17px" }}>
            <span>您好，您的供应商入驻流程已结束！</span>
            <div style={{ marginTop: "16px" }}>
              接下来，您可以登录系统发起新品引入流程啦~
            </div>
          </div>
          <div style={{ fontSize: "24px" }}>
            <a rel="opener" target="_blank" href={"/login"}>
              前往登录
            </a>
          </div>
        </span>
      );
    }
    if (show == "part_pass") {
      return (
        <span>
          <div style={{ margin: "24px 0px", fontSize: "17px" }}>
            <span>
              您好，您上传的基础信息已审核通过！请进行下一步合规资质的填写！
            </span>
          </div>
          <div style={{ fontSize: "24px" }}>{jumpDom()}</div>
        </span>
      );
    }
  };

  useEffect(() => {
    queryRefuseReason();
  }, []);
  return (
    <div className="audit_info">
      <div style={{ textAlign: "center" }}>
        {show == "refuse" && (
          <div>
            <div style={{ color: "red", fontSize: "18px" }}>
              <CloseCircleFilled
                style={{
                  fontSize: "56px",
                  marginRight: "8PX",
                  verticalAlign: "middle",
                }}
              />{" "}
              <span>审核失败</span>
            </div>
            <div style={{ margin: "24px 0px", fontSize: "17px" }}>
              {status === "FinalAuditRefused" ? (
                <span style={{ display: "flex", justifyContent: "center" }}>
                  <span>理由：</span>
                  <span
                    style={{
                      color: "red",
                      marginRight: "8px",
                      fontFamily: "initial",
                      display: "inline-block",
                    }}
                  >
                    <CloseCircleFilled />
                  </span>
                  <span
                    style={{
                      display: "inline-block",
                      maxWidth: 600,
                      textAlign: "left",
                      wordWrap: "break-word",
                    }}
                  >
                    {auditData.check_refuse_reason || "--"}
                  </span>
                </span>
              ) : (
                <span>您好，您提交的入驻申请审核不通过，请你谅解！</span>
              )}
            </div>
            <div style={{ fontSize: "14px" }}>
              审核时间：
              <span>
                {auditData.check_time
                  ? getFormatDate(auditData.check_time)
                  : "--"}
              </span>
            </div>

            {jumpDom(status)}
            <div style={{ fontSize: "24px" }}></div>
          </div>
        )}
        {show == "wait" && (
          <div>
            <div style={{ color: "#faad14", fontSize: "18px" }}>
              <ExclamationCircleFilled
                style={{
                  fontSize: "56px",
                  marginRight: "8PX",
                  verticalAlign: "middle",
                }}
              />{" "}
              <span>信息审核中</span>
            </div>
            <div style={{ margin: "24px 0px", fontSize: "17px" }}>
              <span>
                您好，您的资料正在审核中我们将在两个工作日内完成审核，请耐心等待！
              </span>
            </div>
          </div>
        )}

        {show == "qua_wait" && (
          <div>
            <div style={{ color: "#faad14", fontSize: "18px" }}>
              <ExclamationCircleOutlined
                style={{
                  fontSize: "56px",
                  marginRight: "8PX",
                  verticalAlign: "middle",
                }}
              />{" "}
              <span>信息审核中</span>
            </div>
            <div style={{ margin: "24px 0px", fontSize: "17px" }}>
              <span>
                您好，您的资料正在审核中！我们将会尽快完成内部审核，请耐心等待！
              </span>
            </div>
          </div>
        )}

        {["all_pass", "part_pass"].includes(show) && (
          <div>
            <div style={{ color: "#52c41a", fontSize: "18px" }}>
              <CheckCircleFilled
                style={{
                  fontSize: "56px",
                  marginRight: "8PX",
                  verticalAlign: "middle",
                }}
              />{" "}
              <span>审核通过</span>
            </div>
            {errDom(show)}
          </div>
        )}
        {show == "qua_submit" && (
          <div>
            <div style={{ color: "#52c41a", fontSize: "18px" }}>
              <CheckCircleFilled
                style={{
                  fontSize: "56px",
                  marginRight: "8PX",
                  verticalAlign: "middle",
                }}
              />{" "}
              <span>提交成功！</span>
            </div>
            <div style={{ margin: "24px 0px", fontSize: "17px" }}>
              <div style={{ margin: "24px 0px", fontSize: "17px" }}>
                <span>
                  您好，您填写的资质电子档已提交成功，请及时将资质复印件（加盖公章）进行邮寄，我司收到复印件且核对无误后，会电话联系您，请耐心等待！
                </span>
              </div>
              <div style={{ fontSize: "24px" }}>
                <a
                  className="openerA"
                  rel="opener"
                  target="_blank"
                  href={"/login"}
                >
                  退出登录
                </a>
              </div>
            </div>
          </div>
        )}
        {show == "base_wait_submit" && (
          <div>
            <div style={{ color: "#faad14", fontSize: "18px" }}>
              <ExclamationCircleFilled
                style={{
                  fontSize: "56px",
                  marginRight: "8PX",
                  verticalAlign: "middle",
                }}
              />{" "}
              <span>SCS基础信息待提交</span>
            </div>
            <div style={{ margin: "24px 0px", fontSize: "17px" }}>
              <span>
                您好，您的SCS基础信息尚未提交，请先完善基础信息后再进行后续流程！
              </span>
            </div>
            <div style={{ fontSize: "24px" }}>{jumpDom()}</div>
          </div>
        )}
      </div>
    </div>
  );
};
export default AuditInformation;



// WEBPACK FOOTER //
// ./src/pages/newsuppliersettlement/supplierinformationentry/audit-information.js